import React, { useEffect } from "react";

// based on https://usehooks.com/useOnClickOutside/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useOnClickOutside(ref: React.MutableRefObject<any>, handler: VoidFunction) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref || !ref.current || !ref.current.contains) {
        return;
      }

      // do nothing if clicking ref's element or descendent elements
      if (ref.current.contains(event.target as Node)) {
        return;
      }

      handler();
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}
